/**
 * Shop actions types
 */

export const SHOP_ORDERS_REQUESTED = '[SHOP_ORDERS] REQUESTED';
export const SHOP_ORDERS_SUCCEEDED = '[SHOP_ORDERS] SUCCEEDED';
export const SHOP_ORDERS_FAILED = '[SHOP_ORDERS] FAILED';
